import React from "react";
import Alert from "@propellerads/alert";
import { useAppSelector } from "../../store/configureStore";
import { AlertType } from "../../types/alertType";

const NotixAlert = () => {
  const alerts: AlertType[] = useAppSelector((store) => store.alert.data);

  return (
    <>
      {alerts.map((item) => {
        return (
          <Alert key={item.message} type={item.type} icon={item.icon}>
            {item.message}
          </Alert>
        );
      })}
    </>
  );
};

export default NotixAlert;
